import React, {Component} from 'react';
import {Card, CardHeader, CardText} from 'material-ui/Card';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';

import {fetchGroupUsers, removeUser, updateUser} from '../actions/actions';

class GroupUsers extends Component {

    constructor() {
        super();

        this.state = {
            userRemoveDialog: false,
            userRoleDialog: false
        };
    }

    componentWillMount() {
        this.props.dispatch(fetchGroupUsers());
    }

    handleOpen = (user) => {
        this.setState({userRemoveDialog: true, user});
    };

    handleClose = () => {
        this.setState({userRemoveDialog: false, user: null});
    };

    handleOpenRole = (user) => {
        this.setState({userRoleDialog: true, user});
    };

    handleCloseRole = () => {
        this.setState({userRoleDialog: false, user: null});
    };

    removeUser = (id) => {
        this.handleClose();
        this.props.dispatch(removeUser(id));
    }

    changeRole = (user) => {
        this.handleCloseRole();
        const newRole = (user.role.name.toLowerCase() === 'editor')
            ? 'basic-user'
            : 'editor';
        this.props.dispatch(updateUser(user.id, {role: newRole}));
    }

    renderUser = (user, index) => {

        let userRemoval;
        let userRole;

        if (this.props.auth.user.id === user.id) {
            userRemoval = <span/>;
            userRole = <span/>;
        } else {
            userRemoval = <RaisedButton label="Remove" onTouchTap={ () => this.handleOpen(user)}/>;
            userRole = <RaisedButton label="Change role" onTouchTap={ () => this.handleOpenRole(user)}/>;
        }

        return <tr key={index}>
            <td>{user.name} {this.props.auth.user.id === user.id && (
                    <span>
                        (You)</span>
                )}</td>
            <td>{user.email}</td>
            <td>{user.role.label}</td>
            <td>{userRole}</td>
            <td>{userRemoval}</td>
        </tr>;
    }

    renderRemoveDialog() {
        if (!this.state.userRemoveDialog || this.state.user === null) {
            return <span></span>;
        }

        const user = this.state.user;

        const actions = [
          <FlatButton label="No, cancel" primary onTouchTap={ this.handleClose } />,
          <FlatButton label="Yes, remove user" primary onTouchTap={ () => this.removeUser(user.id) } />
        ];

        return (
            <Dialog actions={actions} modal={false} open={this.state.userRemoveDialog} onRequestClose={this.handleClose}>
                Are you sure you want to remove this user from the group? This will not delete their account, and they can rejoin with an invitation or valid token.
                <br/>
                <br/> {user.name}<br/> {user.email}
            </Dialog>
        );

    }

    renderRoleDialog() {
        if (!this.state.userRoleDialog || this.state.user === null) {
            return <span></span>;
        }

        const user = this.state.user;

        const actions = [
          <FlatButton label="No, cancel" primary onTouchTap={ this.handleCloseRole} />,
          <FlatButton label="Yes, change role" primary onTouchTap={ () => this.changeRole(user)} />
        ];

        const currentRole = user.role.label;
        const newRole = (user.role.name.toLowerCase() === 'editor')
            ? 'Basic User'
            : 'Editor';

        return (
            <Dialog actions={actions} modal={false} open={this.state.userRoleDialog} onRequestClose={this.handleCloseRole}>
                Are you sure you want to change this users role?
                <br/>
                <br/> {user.name}<br/> {user.email}
                <br/><br/>
                Current role: {currentRole}<br/>
                <strong>New role: {newRole}</strong>
            </Dialog>
        );
    }

    render() {
        return (
            <div>
            <Card className="card-wide" key="group-users">
                <CardHeader title="Users"/>
                <CardText>
                    <table className="table">
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Email</th>
                                <th>Role</th>
                                <th/>
                                <th/>
                            </tr>
                        </thead>
                        <tbody>
                            {this.props.group.users.map(this.renderUser)}
                        </tbody>
                    </table>
                </CardText>
            </Card>
            {this.renderRemoveDialog()}
            {this.renderRoleDialog()}
        </div>
        );
    }
}

export default GroupUsers;



// WEBPACK FOOTER //
// ./src/components/GroupUsers.js